function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header-_x2F_-Desktop3",
  transform: "translate(-1747.000000, -10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-_x2F_-ht-_x2F_-Download-Flyer-Copy-2",
  transform: "translate(1747.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M10.2,0.7c0.9,0,1.7,0.1,2.6,0.3c3.4,0.9,6.2,3.5,7.2,6.9c0.6,1.6,0.6,3.3,0.2,5 c-0.5,1.5-1.1,3-1.9,4.4c-2,3.4-4.4,6.7-7,9.7c-0.2,0.3-0.6,0.5-0.9,0.5l0,0l-0.2,0c-0.3-0.1-0.6-0.2-0.8-0.5l0,0l-0.2-0.2 c-0.2-0.3-0.1-0.7,0.1-0.9c0.3-0.2,0.6-0.2,0.9,0l0,0l0.1,0.2c2.6-2.9,4.9-6.1,6.9-9.4c0.8-1.3,1.4-2.6,1.8-4.1 c0.4-1.4,0.3-2.8-0.2-4.2c-0.9-2.9-3.3-5.2-6.3-6C11.7,2.1,11,2,10.2,2l0,0c-4.3,0-8,3-8.8,7.2c-0.3,1.6-0.1,3.3,0.6,4.8 c0.8,1.9,1.9,3.7,3,5.4c0.5,0.7,2,2.8,2.7,3.7l0,0l0.2,0.3c0.2,0.3,0.2,0.7-0.1,0.9c-0.1,0.1-0.3,0.2-0.5,0.1 c-0.2,0-0.3-0.1-0.4-0.3l0,0l-0.2-0.3L6.1,23c-0.7-1-1.7-2.3-2.1-2.8c-1.2-1.8-2.3-3.6-3.2-5.6c-0.8-1.8-1.1-3.7-0.8-5.6 C1.1,4.1,5.3,0.7,10.2,0.7L10.2,0.7L10.2,0.7z M10.3,5.7l0.3,0c2.8,0.2,4.9,2.4,4.9,5.2c0,2.8-2.2,5.1-5,5.2l0,0v0l-0.2,0 c-1.4,0-2.7-0.6-3.7-1.6C5.6,13.7,5,12.4,5,11c0-1.4,0.5-2.8,1.5-3.8S8.9,5.6,10.3,5.7L10.3,5.7z M10.3,7L10,7 C9,7.1,8.1,7.5,7.4,8.2C6.7,8.9,6.3,9.9,6.3,11c0,1,0.4,2,1.2,2.7c0.7,0.7,1.8,1.2,2.8,1.2l0,0l0.2,0c2-0.2,3.6-1.9,3.6-3.9 C14.1,8.8,12.4,7,10.3,7L10.3,7z"
}))));

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 28",
    style: {
      enableBackground: "new 0 0 21 28"
    },
    width: "21px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.47ee71f9.svg";
export { ForwardRef as ReactComponent };